import { render, staticRenderFns } from "./TriggerUpdate.vue?vue&type=template&id=c16be458&scoped=true"
import script from "./TriggerUpdate.vue?vue&type=script&lang=js"
export * from "./TriggerUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16be458",
  null
  
)

export default component.exports